import { Scene } from "phaser";
import { Sprite, Container } from "../../../types";

export type IAnimationKey = "air" | "fireball" | "flash" | "water-splash";

const frameCount = { air: 17, fireball: 18, flash: 14, "water-splash": 17 } as const;

export function generateAnimation(scene: Phaser.Scene, key: IAnimationKey) {
  const config = {
    key,
    frames: scene.anims.generateFrameNames("atlas", {
      prefix: `effects/${key}/${key}`,
      start: 1,
      end: frameCount[key] - 1,
    }),
    showOnStart: true,
    hideOnComplete: true,
    framerate: 20,
  };
  scene.anims.create(config);
}

export function generateAnimations(scene: Phaser.Scene) {
  const animationkeys: IAnimationKey[] = ["air", "fireball", "flash", "water-splash"];
  animationkeys.forEach((e) => generateAnimation(scene, e));
  return scene.add.sprite(0, 0, "atlas").setName("animation").setVisible(false);
}

export function play(container: Container, key: IAnimationKey, sprite?: Sprite) {
  sprite?.setPosition(container.x, container.y).setDepth(2);
  sprite?.anims?.play(key);
}
